//authReducer.js
import { LOGIN_SUCCESS, LOGOUT, PERMISSION } from '../actions/action'

const initialState = {
  isAuthenticated: false,
  admin: null,
  user: null,
  token: null,
  refreshToken: null,
  permissions: [],
}

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOGIN_SUCCESS: {
      return {
        ...state,
        isAuthenticated: true,
        admin: action.payload.admin,
        token: action.payload.token,
        refreshToken: action.payload.refreshToken,
        permissions: action.payload.admin.permissions || []
      }
    }

    case LOGOUT: {
      return {
        ...initialState, // reset everything properly
      }
    }

    default:
      return state; // ✅ do not spread

  }
}

export default authReducer
